import { ProgressSpinner } from "primereact/progressspinner";
import "../style/chat_loading_style.css";
import styles from "../style/chat_backbone_comp.module.css";

const ChatLoadingComp = () => {
  return (
    <div className={`h-dvh flex flex-col items-center justify-center bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 text-white`}>
      <ProgressSpinner strokeWidth="3" animationDuration=".5s" className="chat-loading-spinner" />
    </div>
  );
};

export default ChatLoadingComp;
